<template>
  <div
    :style="`width: ${props.maxWidth}px`"
    :class="`tw-flex tw-h-[8px] tw-bg-[#E4F1FF] tw-rounded-[50px]  ${className}`"
  >
    <div
      :style="`width: ${progressClass}px`"
      :class="` tw-flex tw-h-[8px] tw-bg-[#387DFF]  tw-rounded-[50px] `"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
const props = defineProps({
  className: {
    type: String,
    required: false,
    default: "",
  },
  maxWidth: {
    type: Number,
    required: false,
    default: 133,
  },
  progress: {
    type: Number,
    required: false,
    default: 0,
  },
});
const progressClass = computed(() => {
  return Number(props.progress * props.maxWidth) / 100;
});
</script>
